import { create } from 'zustand';

export const useShippingCountryStore = create(set => ({
  shippingCountry: '',
  setShippingCountry: location => set({ shippingCountry: location }),
}));
